import { ProductService, ProductProvider, HttpService } from '@lk/api'

export const makeProductService = (http: HttpService, baseUrl: string) =>
  new ProductService(new ProductProvider(http, baseUrl))
